export default "__VITE_ASSET__4e84b020__"